/**
 * Commerce Connector / ArticleReach constants shared between client and server.
 *
 * NOTE: CC_TOKEN should eventually be sourced from the config service on the server
 * and passed to the client via initial SSR state. Until that migration is done,
 * this file provides a single source of truth to simplify rotation and prevent drift.
 */
class WtbConst {
    /**
     * Commerce Connector API token.
     * Used in ArticleReach REST calls (server) and the CC widget script tag (client).
     */
    static CC_TOKEN = '99c976f1d1aab575ceaba5749f1c60fa4df039d9'

    /**
     * ArticleReach REST API base URL.
     */
    static CC_API_URL = 'https://api-retailer.global.commerce-connector.com/REST/2.0/ArticleReach/'

    /**
     * Commerce Connector WTB widget script URL loaded client-side.
     */
    static CC_WIDGET_URL = 'https://fi-v2.global.commerce-connector.com/cc.js'

    /**
     * Commerce Connector Service Locator widget script URL loaded client-side.
     */
    static CC_SERVICE_LOCATOR_URL = 'https://storefindernew.commerce-connector.com/storefinder.min.js'

    /**
     * Minimum valid MinDeliveryTime value (days) from ArticleReach.
     * Values below this (0 = out of stock, -1 = no shops) are not deliverable.
     */
    static MIN_DELIVERY_TIME = 1

    /**
     * Maximum valid MinDeliveryTime value (days) from ArticleReach.
     * Values above this (361+, 999 = unknown) are not considered deliverable.
     */
    static MAX_DELIVERY_TIME = 360

    /**
     * Value to decide when to use bulk POST vs single GET for Commerce Connector availability checks.
     */
    static BULK_THRESHOLD = 1 
}

export default WtbConst
